export const STATUSES_REQUIRING_DRIVER = [
  'DriverAssigned',
  'DriverConfirmed',
  'DriverOnTheWay',
] as const;

export const RECALL_STATUS = 'Recall';

export const requiresDriver = (statusName: string): boolean => {
  return STATUSES_REQUIRING_DRIVER.includes(
    statusName as (typeof STATUSES_REQUIRING_DRIVER)[number]
  );
};

export const canShowRecallTransition = (statusName: string | null | undefined): boolean => {
  if (!statusName) return false;
  return (STATUSES_REQUIRING_DRIVER as readonly string[]).includes(statusName);
};

/**
 * GraphQL may expose Recall on driver-status rows for everyone; Recall is only valid when the
 * assigned driver is blocked. Hide Recall from API transitions when the driver is active.
 *
 * When {@link currentStatusName} is already Recall, the Recall transition is always removed
 * to prevent the Recall → Recall self-transition.
 */
export function filterStatusTransitionsHideRecallUnlessBlockedDriver<T extends { next: string }>(
  transitions: readonly T[] | null | undefined,
  isDriverBlocked: boolean,
  currentStatusName?: string | null
): T[] {
  if (!transitions?.length) return [];
  if (currentStatusName === RECALL_STATUS) {
    return transitions.filter((t) => t.next !== RECALL_STATUS);
  }
  if (isDriverBlocked) return [...transitions];
  return transitions.filter((t) => t.next !== RECALL_STATUS);
}
